import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule } from 'ngx-toastr';


import { AppRoutingModule } from './app.routing';
import { ComponentsModule } from './components/components.module';

import { AppComponent } from './app.component';

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { SignupComponent } from './auth/signup/signup.component';
import { AdminLayoutModule } from './layouts/admin-layout/admin-layout.module';
// import {NgModalsComponent, NgModalsDirective} from 'ng-modals';
// import {ModalModule} from 'angular-custom-modal';
import { RestService } from './services/rest.service';
import { UserLoginComponent } from './user-login/user-login.component';
import { UserSignupComponent } from './user-signup/user-signup.component';
import { CategoryComponent } from './category/category/category.component';
import { AddCategoryComponent } from './category/add-category/add-category.component';
import { UpdateCategoryComponent } from './category/update-category/update-category.component';

// import { RestaurantModule } from './restaurant/restaurant.module';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ComponentsModule,
    RouterModule,
    AppRoutingModule,
    AdminLayoutModule,
    NgbModule,
    // ModalModule,
  //  BrowserAnimationsModule,
    // RestaurantModule,


    ToastrModule.forRoot({
      positionClass: 'toast-top-right',
    })
  ],
  declarations: [

    AppComponent,
    AdminLayoutComponent,
    SignupComponent,
    UserLoginComponent,
    UserSignupComponent,

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
